import api from "../../../helpers/api";

/**
 * Called in Cob.js in componentDidMount. Used to perform whitelabel specific logic when the small
 * cob initiates.
 */
export const partnerStrategies = {
    default: async ({session, partner, newStateProps}) =>
    {
        // No-op default
    },

    "futur-withdrawal": async ({session, partner, newStateProps}) =>
    {
        console.log("Fetching WithdrawalInformation from Futur...");
        if (!session || !session.context || !session.context.customer)
        {
            throw new Error("SESSION_NOT_SET");
        }

        const response = await api("/futur/withdrawal", {
            identity: session.context.customer.id,
            authToken: session.authToken
        });

        if (!response)
        {
            throw new Error("Depå eller försäkring saknas för denna kund. Var vänlig kontrollera person-/orgnummer.");
        }

        newStateProps.variables = response;
    }
};


// WEBPACK FOOTER //
// ./src/routes/Cob/strategies/PartnerStrategies.js